<template>
  <div>
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div
      class="mobileview"
      style=" 
      background: #31333e 0% 0% no-repeat padding-box;
      width: 100%;
      box-shadow: 0px 3px 20px #00000029;"
    >
      <img
        src="../assets/logo/LogoGreen.png"
        width="150"
        alt="logo"
        class="img-fluid"
      />
    </div>

    <div class="desktopView">
      <div class="header-userflow">
        <div class="heading_user">
          <!-- <span class="logo_white">Sell</span
          ><span class="logo_green">Well</span> -->
          <img
            src="../assets/logo/LogoGreen.png"
            width="150"
            alt="logo"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <div class="desktop-margins">
      <div class="col">
        <div class="mobileview background_color alignment_longText">
          <h5 class="text-center text_color ">{{ payload.shopname }}</h5>

          <div>{{ payload.shopdesc }}</div>
        </div>
        <div class="mobileview">
          <div
            class="d-flex justify-space-between mobileview"
            style="padding-top: 5px; padding-bottom: 5px"
          >
            <div class="justify-start">
              <span class="text_color">{{
                $t("newUi.userFlow.itemsSelect")
              }}</span>
              <span class="count_space" id="Mob_item">0</span>
            </div>
            <div class="justify-end">
              <span class="text_color">{{ $t("newUi.userFlow.total") }}</span
              ><span>{{ payload.symbol }}</span>
              <span class="count_space" id="Mob_total">0</span>
            </div>
          </div>
        </div>
        <div class="desktopView">
          <div class="header-text">{{ payload.shopname }}</div>
          <div class="d-flex justify-space-between">
            <div
              class="justify-start col description-text alignment_longText"
              style="padding: 0px"
            >
              {{ payload.shopdesc }}
            </div>
            <div class="justify-end">
              <span class="text_color">{{
                $t("newUi.userFlow.itemsSelect")
              }}</span>
              <span class="count_space" id="item">0</span>
              <span class="text_color">{{ $t("newUi.userFlow.total") }}</span
              ><span>{{ payload.symbol }}</span>
              <span class="count_space" id="total">0</span>
            </div>
          </div>
        </div>
        <div v-if="payload.type == 'Ordering form'">
          <div class="" v-for="item in category_list" :key="item.pos">
            <div class="item_category mt-3">
              <div
                class="col text_bold"
                style="padding-top: 5px; padding-bottom: 5px"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="grid-container2 consumer-product">
              <div
                class="row item_box mt-3"
                style="border-radius: 0px"
                v-for="list in item.items"
                :key="list.pos"
              >
                <userOrderList
                  v-bind:payload="payload"
                  :list="list"
                ></userOrderList>
              </div>
            </div>
          </div>
          <div
            class=""
            v-if="
              payload.catalogue &&
                payload.catalogue.filter((o) => o.category == '').length != 0
            "
          >
            <div class="item_category mt-3">
              <div
                class="col text_bold"
                style="padding-top: 5px; padding-bottom: 5px"
              >
                {{ $t("newUi.adminViewform.noCat") }}
              </div>
            </div>
            <div class="grid-container2 consumer-product">
              <div
                class="row item_box mt-3"
                style="border-radius: 0px"
                v-for="list in payload.catalogue.filter(
                  (o) => o.category == ''
                )"
                :key="list.pos"
              >
                <userOrderList
                  v-bind:payload="payload"
                  :list="list"
                ></userOrderList>
              </div>
            </div>
          </div>
        </div>
        <div v-if="payload.type == 'Catalogue'">
          <div class="" v-for="item in category_list" :key="item.pos">
            <div class="item_category mt-3">
              <div
                class="col text_bold"
                style="padding-top: 5px; padding-bottom: 5px"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="grid-container2 consumer-product">
              <div
                class="row item_box mt-3"
                style="border-radius: 0px"
                v-for="list in item.items"
                :key="list.pos"
              >
                <userCatelogueList
                  v-bind:payload="payload"
                  :list="list"
                ></userCatelogueList>
              </div>
            </div>
          </div>
          <div
            class=""
            style="padding: 0px"
            v-if="
              payload.catalogue &&
                payload.catalogue.filter((o) => o.category == '').length != 0
            "
          >
            <div class="item_category mt-3">
              <div
                class="col text_bold"
                style="padding-top: 5px; padding-bottom: 5px"
              >
                {{ $t("newUi.adminViewform.noCat") }}
              </div>
            </div>
            <div class="grid-container2 consumer-product">
              <div
                class="row item_box mt-3"
                style="border-radius: 0px"
                v-for="list in payload.catalogue.filter(
                  (o) => o.category == ''
                )"
                :key="list.pos"
              >
                <userCatelogueList
                  v-bind:payload="payload"
                  :list="list"
                ></userCatelogueList>
              </div>
            </div>
          </div>
        </div>

        <div class="mobileview">
          <div v-if="payload.type == 'Ordering form'">
            <v-col
              align="center"
              v-if="
                this.payload.catalogue && this.payload.catalogue.length != 0
              "
            >
              <v-btn
                color="#128c7e"
                class="button_padding"
                @click="submit_order()"
                >{{ $t("newUi.OTPFlow.placeOrderButton") }}</v-btn
              >
            </v-col>
          </div>
          <div v-else>
            <v-col
              align="center"
              v-if="
                this.payload.catalogue && this.payload.catalogue.length != 0
              "
            >
              <v-btn
                color="#128c7e"
                class="button_padding"
                @click="submit_order_catalogue()"
                >{{ $t("newUi.userFlow.expInterest") }}</v-btn
              >
            </v-col>
          </div>
        </div>
        <div class="desktopView">
          <div v-if="payload.type == 'Ordering form'">
            <v-col
              align="center"
              v-if="
                this.payload.catalogue && this.payload.catalogue.length != 0
              "
            >
              <v-btn
                color="#128c7e"
                class="button_padding"
                @click="submit_order_desktop()"
                >{{ $t("newUi.OTPFlow.placeOrderButton") }}</v-btn
              >
            </v-col>
          </div>
          <div v-else>
            <v-col
              align="center"
              v-if="
                this.payload.catalogue && this.payload.catalogue.length != 0
              "
            >
              <v-btn
                color="#128c7e"
                class="button_padding"
                @click="submit_order_desktop_catalogue()"
                >{{ $t("newUi.userFlow.expInterest") }}</v-btn
              >
            </v-col>
          </div>
        </div>

        <v-bottom-sheet v-model="form_submit">
          <v-sheet class="text-center bottom_modal" height="auto">
            <!-- <div class="pt-8 text_color">Delete Product</div> -->

            <v-container class="pt-8 text-center">
              <v-btn @click="navws" class="button_padding" color="#8AB26D">{{
                $t("newUi.userFlow.request")
              }}</v-btn>
              <div class="col">
                <div>{{ $t("newUi.userFlow.expDesc") }}</div>
                <div>{{ $t("newUi.userFlow.expSend") }}</div>
              </div>
            </v-container>
          </v-sheet>
        </v-bottom-sheet>
        <v-bottom-sheet class="mobileview" v-model="submit_catelogue_form">
          <v-sheet class="text-center bottom_modal" height="auto">
            <!-- <div class="pt-8 text_color">Delete Product</div> -->

            <span
              class="cursor-pointer closeIcon"
              @click="submit_catelogue_form = false"
              ><img style="width:16px;height:16px" src="../assets/close.svg"
            /></span>
            <v-container class="pt-8 text-center">
              <div class="col">
                <div>{{ $t("newUi.userFlow.expInterestDesc") }}</div>
                <div>{{ $t("newUi.userFlow.sendDesc") }}</div>
              </div>
              <v-btn
                @click="navwsCatalog"
                class="button_padding"
                color="rgb(18, 140, 126)"
                >{{ $t("newUi.userFlow.expInterest") }}
              </v-btn>
            </v-container>
          </v-sheet>
        </v-bottom-sheet>
        <v-dialog
          class="desktopView"
          v-model="submit_catelogue_form_desktop"
          content-class="delete_dialog1"
        >
          <v-container class="delete_dialog1">
            <!-- <div class="d-flex justify-space-between text_color"> -->
            <div
              class="d-flex justify-end justify-content-end text_color"
              style="font-size: 20px"
            >
              <span
                class="cursor-pointer"
                @click="submit_catelogue_form_desktop = false"
                >x</span
              >
            </div>
            <!-- </div> -->
            <v-container class="text-center">
              <div class="col" style="margin-top: 15px;">
                <div>{{ $t("newUi.userFlow.expInterestDesc") }}</div>
                <div>{{ $t("newUi.userFlow.sendDesc") }}</div>
              </div>
              <v-btn
                @click="navwsCatalog"
                class="button_padding"
                color="rgb(18, 140, 126)"
                style="margin-top: 15px;"
                >{{ $t("newUi.userFlow.expInterest") }}</v-btn
              >
            </v-container>
          </v-container>
        </v-dialog>
        <v-dialog
          class="desktopView"
          v-model="form_submit_desktop"
          content-class="delete_dialog1"
        >
          <v-container class="delete_dialog1">
            <!-- <div class="d-flex justify-space-between text_color"> -->
            <div
              class="d-flex justify-end justify-content-end text_color"
              style="font-size: 14px"
            >
              <span class="cursor-pointer" @click="form_submit_desktop = false"
                >x</span
              >
            </div>
            <!-- </div> -->
            <v-container class="text-center">
              <v-btn @click="navws" class="button_padding" color="#8AB26D">{{
                $t("newUi.userFlow.request")
              }}</v-btn>
              <div class="col">
                <div>{{ $t("newUi.userFlow.expDesc") }}</div>
                <div>{{ $t("newUi.userFlow.expSend") }}</div>
              </div>
            </v-container>
          </v-container>
        </v-dialog>
        <v-dialog
          class="desktopView"
          v-model="form_place_order_desktop"
          content-class="delete_dialog1"
        >
          <v-container class="1" style="height: 300px">
            <!-- <div class="d-flex justify-space-between text_color"> -->
            <div
              class="d-flex justify-end justify-content-end text_color"
              style="font-size: 20px;"
            >
              <span class="cursor-pointer" @click="closing_place_order_desktop"
                >x</span
              >
            </div>
            <!-- </div> -->
            <v-container class="text-center">
              <div class="col" style="padding-top: 0px;">
                <div>
                  <p style="    padding-bottom: 15px; font-weight: bolder;">
                    {{ $t("newUi.userFlow.placeOrderInfo1") }}
                  </p>
                </div>
                <div>
                  <p style="    text-align: left;padding-bottom: 10px;">
                    {{ $t("newUi.userFlow.placeOrderInfo2")
                    }}<b style="font-weight:700"
                      >#{{ this.$store.state.OrderId }}</b
                    >.
                  </p>
                </div>
                <div>
                  <p style="    text-align: left;padding-bottom: 10px;">
                    {{ $t("newUi.userFlow.placeOrderInfo3") }}
                  </p>
                </div>
              </div>
              <v-btn @click="navws" class="button_padding" color="#128c7e">{{
                $t("newUi.userFlow.buttonGoToWhatsSpp")
              }}</v-btn>
            </v-container>
          </v-container>
        </v-dialog>
        <v-bottom-sheet v-model="form_place_order">
          <v-sheet class="text-center bottom_modal" height="auto">
            <!-- <div class="pt-8 text_color">Delete Product</div> -->
            <div
              class="d-flex justify-end justify-content-end text_color"
              style="font-size: 20px;"
            >
              <span
                class="cursor-pointer"
                style="float:right;padding-right:25px;"
                @click="closing_place_order"
                >x</span
              >
            </div>
            <v-container class="pt-8 text-center">
              <div class="col" style="padding-top: 0px;">
                <div>
                  <p style="    padding-bottom: 15px; font-weight: bolder;">
                    {{ $t("newUi.userFlow.placeOrderInfo1") }}
                  </p>
                </div>
                <div>
                  <p style="    text-align: left;padding-bottom: 10px;">
                    {{ $t("newUi.userFlow.placeOrderInfo2")
                    }}<b style="font-weight:700"
                      >#{{ this.$store.state.OrderId }}</b
                    >
                  </p>
                </div>
                <div>
                  <p style="    text-align: left;padding-bottom: 10px;">
                    {{ $t("newUi.userFlow.placeOrderInfo3") }}
                  </p>
                </div>
              </div>
              <v-btn @click="navws" class="button_padding" color="#128c7e">{{
                $t("newUi.userFlow.buttonGoToWhatsSpp")
              }}</v-btn>
            </v-container>
          </v-sheet>
        </v-bottom-sheet>
        <v-dialog
          class="desktopView"
          v-model="form_otp_desktop"
          content-class="delete_dialog2"
        >
          <v-container class="1" style="height: 300px">
            <!-- <div class="d-flex justify-space-between text_color"> -->
            <div
              class="d-flex justify-end justify-content-end text_color"
              style="font-size: 20px;"
            >
              <span class="cursor-pointer" @click="closing_OTP_desktop">x</span>
            </div>
            <!-- </div> -->
            <v-container class="text-center">
              <div class="col">
                <div>
                  <p
                    style="margin-bottom: 15px;
                    font-weight: 500;
                    font-size: 17px;"
                  >
                    {{ $t("newUi.OTPFlow.OTPVerification") }}
                  </p>
                </div>
                <div>
                  <form
                    class="w3-container"
                    style="text-align: left; position: relative;"
                  >
                    <div>
                      <!-- rg -->
                      <v-btn
                        plain
                        :disabled="this.toggleOTP"
                        @click="sendOTP"
                        style="    top: 45px;
    right: 10px;
    float: right;
    position: absolute;
    text-decoration: underline;
    text-decoration-color: #128c7e;
    text-transform: none;"
                      >
                        <p
                          style="color: #128c7e;
    font-size: small;"
                        >
                          {{
                            this.OTP_text == ""
                              ? $t("newUi.OTPFlow.GetOTP")
                              : this.OTP_text
                          }}
                        </p>
                      </v-btn>
                      <!-- rg -->
                    </div>
                    <div>
                      <p
                        style="font-size: 12px;
    font-weight: 100;"
                      >
                        {{ $t("newUi.OTPFlow.MobileNo") }}
                      </p>
                    </div>
                    <!-- <input
                      id="inputmobileno"
                      :disabled="this.toggleOTP"
                      v-model="mobileno"
                      v-on:keyup="isNumber('Desktop')"
                      placeholder="Mobile number"
                      maxlength="10"
                      type="text"
                      value=""
                      style="border: none; 
    border-bottom: solid;
    border-bottom-width: thin;
        padding: 0px;
        border-radius: 0px;
    margin: 1px;"
                    /> -->
                    <vue-tel-input
                      style="border: 1px solid #bbb"
                      :autoFormat="false"
                      :showDialCode="true"
                      :validCharactersOnly="true"
                      v-model="mobileno"
                      :autoDefaultCountry="true"
                      :dropdownOptions="{
                        showFlags: true,
                        showDialCodeInList: true,
                        showDialCodeInSelection: true,
                      }"
                      :inputOptions="{
                        type: 'number',
                        placeholder: this.placeHolderText(),
                      }"
                      @validate="isNumber"
                      @country-changed="countryChanged"
                      inputOptions.placeholder=""
                      mode="international"
                      id="create_for_mobile"
                      :enabledCountryCode="true"
                      inputId="create_for_mobile"
                    ></vue-tel-input>
                    <div class="tel-error" v-show="!this.isValid">
                      {{ $t("newUi.OTPFlow.invalidPhone") }}
                    </div>
                    <input
                      v-model="OTP"
                      v-on:keyup="IsOTP('Desktop')"
                      class="w3-input"
                      type="number"
                      :placeholder="$t('newUi.OTPFlow.OTP')"
                      onKeyPress="if(this.value.length>=4) return false;"
                      style=" 
        width:100% !important                  
        border-bottom-width: thin;
        padding: 5px;
        margin: 1px;
        border-radius: 5px;
        margin-top: 30px;
        border: 1px solid #bbb
        border-radius: 5px"
                    />
                  </form>
                </div>
                <!-- <div> {{ getMobileNumber() }}</div> -->
              </div>
              <v-btn
                @click="OTP_Verification"
                class="button_padding"
                color="#128c7e"
                >{{ $t("newUi.userFlow.submitButton") }}</v-btn
              >
            </v-container>
          </v-container>
        </v-dialog>
        <v-bottom-sheet v-model="form_otp">
          <v-sheet class="text-center bottom_modal" height="auto">
            <!-- <div class="pt-8 text_color">Delete Product</div> -->
            <v-container
              class="1"
              style="height: 300px; padding-left:0px;padding-right:0px"
            >
              <!-- <div class="d-flex justify-space-between text_color"> -->
              <div
                class="d-flex justify-end justify-content-end text_color"
                style="font-size: 20px;"
              >
                <span
                  class="cursor-pointer"
                  style="margin-right: 20px"
                  @click="closing_OTP"
                  >x</span
                >
              </div>
              <!-- </div> -->
              <v-container
                class="text-center"
                style=" padding-left:0px;padding-right:0px"
              >
                <div class="col">
                  <div>
                    <p
                      style="margin-bottom: 15px;
    font-weight: 500;
    font-size: 17px;"
                    >
                      {{ $t("newUi.OTPFlow.OTPVerification") }}
                    </p>
                  </div>
                  <div>
                    <form
                      class="w3-container"
                      style="text-align: left; position: relative;"
                    >
                      <div>
                        <!-- rg -->
                        <v-btn
                          plain
                          :disabled="this.toggleOTP"
                          @click="sendOTP_Mobile"
                          style="    top: 45px;
    right: -10px;
    float: right;
    font-size:8px;
    position: absolute;
    text-decoration: underline;
    text-decoration-color: #128c7e;
    text-transform: none;"
                        >
                          <p
                            style="color: #128c7e;
    font-size: small;"
                          >
                            {{
                              this.OTP_text == ""
                                ? $t("newUi.OTPFlow.GetOTP")
                                : this.OTP_text
                            }}
                          </p>
                        </v-btn>
                        <!-- rg -->
                      </div>
                      <div>
                        <p
                          style="font-size: 12px;
    font-weight: 100;"
                        >
                          {{ $t("newUi.OTPFlow.MobileNo") }}
                        </p>
                      </div>

                      <vue-tel-input
                        style="border: 1px solid #bbb"
                        :autoFormat="false"
                        :showDialCode="true"
                        :value="mobileno"
                        v-model="mobileno"
                        :autoDefaultCountry="true"
                        :dropdownOptions="{
                          showFlags: true,
                          showDialCodeInList: true,
                          showDialCodeInSelection: true,
                        }"
                        :inputOptions="{
                          placeholder: this.placeHolderText(),
                          type: 'number',
                        }"
                        @validate="isNumber_mobile"
                        @country-changed="countryChanged"
                        :validCharactersOnly="true"
                        inputOptions.placeholder=""
                        mode="international"
                        id="create_for_mobile"
                        :enabledCountryCode="true"
                        inputId="create_for_mobile"
                      ></vue-tel-input>
                      <div class="tel-error" v-show="!this.isValid">
                        {{ $t("newUi.OTPFlow.invalidPhone") }}
                      </div>
                      <!-- <input
                        v-model="mobile"
                        :disabled="this.toggleOTP"
                        v-on:keyup="isNumber('Mobile')"
                        placeholder="Mobile number"
                        type="text"
                        maxlength="10"
                        value=""
                        style="border: none; 
    border-bottom: solid;
    border-bottom-width: thin;
        padding: 0px;
        border-radius: 0px;
    margin: 1px;"
                      /> -->
                      <input
                        v-model="OTP_mobile"
                        v-on:keyup="IsOTP('Mobile')"
                        class="w3-input"
                        type="number"
                        :placeholder="$t('newUi.OTPFlow.OTP')"
                        onKeyPress="if(this.value.length>=4) return false;"
                        style="
    width:100% !important
    border-bottom-width: thin;
        padding: 5px;
    margin: 1px;
        border-radius: 5px;
        margin-top: 30px;border: 1px solid #bbb"
                      />
                    </form>
                  </div>
                  <!-- <div> {{ getMobileNumber() }}</div> -->
                </div>
                <v-btn
                  @click="OTP_Verification_mobile"
                  class="button_padding"
                  color="#128c7e"
                  >{{ $t("newUi.userFlow.submitButton") }}</v-btn
                >
              </v-container>
            </v-container>
          </v-sheet>
        </v-bottom-sheet>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { analytics, setLocale } from "../services/firebase";
import i18n from "../i18n";
import userOrderList from "./userOrderList";
import userCatelogueList from "./userCatelogueList";
import { save, sendOtpMessage, downloadUrl } from "../services/firebase";
import store from "../store/store";
export default {
  name: "GsCatelogueForm",
  props: [""],

  data() {
    // var category_list = [];
    return {
      // category_list,
      Initial_OTP: false,
      OTP_text: "",
      form_otp: false,
      // mobile: "",
      OTP_mobile: "",
      mobileno: "",
      OTP: "",
      countDown: 60,
      toggleOTP: false,
      form_otp_desktop: false,
      form_place_order_desktop: false,
      form_place_order: false,
      form_submit: false,
      submit_catelogue_form: false,
      form_submit_desktop: false,
      submit_catelogue_form_desktop: false,
      set_overlay: false,
      counter_flag: true,
      previous_number: "",
      country: {},
      valid: true,
      payload: {},
      list: [],
    };
  },

  computed: {
    isEditable: function() {
      if (this.$route.name === "viewform") return false;
      return true;
    },
    type: function() {
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },
    category_list: function() {
      var catName = "";
      let data = "";
      if (this.payload.catalogue) {
        for (var i = 0; i < this.payload.catalogue.length; i++) {
          let list = this.payload.catalogue[i];
          if (list.type == "category") {
            catName = list.name;
          }
          if (list.type == "item" && list.category == undefined) {
            list.category = catName;
          }
        }
        data = this.payload.catalogue.filter(
          (o) => o.type == "category" && o.name != ""
        );
        data.forEach((list) => {
          list.items = [];
          if (this.payload.catalogue) {
            list.items = this.payload.catalogue.filter(
              (o) => o.category == list.name
            );
          }
        });
      }
      return data;
    },
    no_order_selected: function() {
      let qtt = 0;
      if (this.payload.type == "Ordering form") {
        let items = this.payload.catalogue.filter((o) => o.type == "item");
        for (var item of items) {
          qtt += item.qtty;
        }
      } else {
        if (this.payload.catalogue) {
          let items = this.payload.catalogue.filter((o) => o.type == "item");
          for (var p_item of items) {
            qtt += p_item.qtty;
          }
        }
      }
      return qtt;
    },
    isValid: function() {
      return this.mobileno === "" ? true : this.valid;
    },
  },
  mounted() {
    setLocale();
    this.fetchData_();
    this.payload.amount = 0;
  },
  components: {
    userOrderList,
    userCatelogueList,
  },
  methods: {
    countryChanged(country) {
      this.country = country;
    },

    placeHolderText() {
      var msgPlaceHolder = i18n.t("newUi.OTPFlow.MobileNumber");
      return msgPlaceHolder;
    },
    submit_order_catalogue: async function() {
      if (this.payload.amount > 0) {
        this.submit_catelogue_form = true;
      } else {
        alert(i18n.t("alertText.Placecatalogue"));
      }
    },
    submit_order: async function() {
      if (this.payload.amount > 0) {
        this.form_otp = true;
        // let Order_id = await save(this.$store.state,this.mobile);
        // store.dispatch("setOrderId", Order_id);
        // this.form_place_order = true;
        // if (this.$store.state.currentForm.type == "Ordering form") {
        // this.form_submit = true;
        // } else {
        // this.submit_catelogue_form = true;
        // }
      } else {
        if (this.payload.type == "Ordering form") {
          alert(i18n.t("alertText.PlaceOrder"));
        } else {
          alert(i18n.t("alertText.Placecatalogue"));
        }
      }
    },
    submit_order_desktop: async function() {
      if (this.payload.amount > 0) {
        this.form_otp_desktop = true;
      } else {
        if (this.payload.type == "Ordering form") {
          alert(i18n.t("alertText.PlaceOrder"));
        } else {
          alert(i18n.t("alertText.Placecatalogue"));
        }
      }
    },
    submit_order_desktop_catalogue: async function() {
      if (this.payload.amount > 0) {
        this.submit_catelogue_form_desktop = true;
      } else {
        alert(i18n.t("alertText.Placecatalogue"));
      }
    },
    isNumber(phoneObject) {
      this.OTP = "";
      if (phoneObject.nationalNumber) {
        this.valid = phoneObject.valid;
      }
      let Phone =
        phoneObject.countryCallingCode + "" + phoneObject.nationalNumber;
      if (this.previous_number != "" && this.previous_number != Phone) {
        this.OTP = "";
        if (this.countDown != 0 && this.countDown != 60) {
          this.counter_flag = false;
          setTimeout(() => {
            this.countDown = 0;
            this.OTP_text = i18n.t("newUi.OTPFlow.GetOTP");
          }, 1000);
        } else {
          this.OTP_text = i18n.t("newUi.OTPFlow.GetOTP");
        }
      } else if (this.previous_number != "" && this.previous_number == Phone) {
        this.OTP_text = i18n.t("newUi.OTPFlow.resendOTP");
      }
    },
    isNumber_mobile(phoneObject) {
      this.OTP_mobile = "";
      if (phoneObject.nationalNumber) {
        this.valid = phoneObject.valid;
      }
      let Phone =
        phoneObject.countryCallingCode + "" + phoneObject.nationalNumber;
      if (this.previous_number != "" && this.previous_number != Phone) {
        if (this.countDown != 0 && this.countDown != 60) {
          this.counter_flag = false;
          setTimeout(() => {
            this.countDown = 0;
            this.OTP_text = i18n.t("newUi.OTPFlow.GetOTP");
          }, 1000);
        } else {
          this.OTP_text = i18n.t("newUi.OTPFlow.GetOTP");
        }
      } else if (this.previous_number != "" && this.previous_number == Phone) {
        this.OTP_text = i18n.t("newUi.OTPFlow.resendOTP");
      }
    },
    IsOTP(type) {
      if (type == "Desktop") {
        this.OTP = this.OTP.replace(/\D/g, "");
      } else if (type === "Mobile") {
        this.OTP_mobile = this.OTP_mobile.replace(/\D/g, "");
      }
    },
    closing_OTP_desktop() {
      this.form_otp_desktop = false;
      this.mobileno = "";
      this.Initial_OTP = false;
      this.previous_number = "";
      this.OTP = "";
      this.counter_flag = false;
      this.valid = true;
      setTimeout(() => {
        this.countDown = 0;
        this.otpText();
      }, 1000);
    },
    closing_OTP() {
      this.form_otp = false;
      this.mobileno = "";
      this.Initial_OTP = false;
      this.previous_number = "";
      this.OTP_mobile = "";
      this.valid = true;
      this.counter_flag = false;
      setTimeout(() => {
        this.countDown = 0;
        this.otpText();
      }, 1000);
    },
    closing_place_order_desktop() {
      this.form_place_order_desktop = false;
      this.$router.go();
    },
    closing_place_order() {
      this.form_place_order = false;
      this.$router.go();
    },
    submitOTP() {
      var OTP = document.getElementById("inputOTP").value;
      console.log(OTP);
      var regx = /^[0-9]\d{3}$/;
      if (regx.test(OTP)) {
        alert(OTP);
        //this.countDownTimer();
        console.log("valid OTP");
        // api call for validating OTP
      } else alert(OTP);
    },
    fetchData_() {
      this.set_overlay = true;

      if (this.$route.params.formid) {
        // this.loadLocale_(this.$route.params.formid, function() {});
      }
      // var state = this.$store.state;
      // console.log('state',state);
      // state.currentFormPos = this.$route.params.formpos;
      // var payload=this.payload;
      this.payload.FormPos = this.$route.params.formpos;
      // var store = this.$store;
      var elethis = this;
      this.loadFile_(
        this.$route.params.formid,
        this.$route.params.formpos,
        function(error) {
          if (error) {
            //TODO skeleton data
            Vue.nextTick(() => {
              elethis.set_overlay = false;
              // store.dispatch("setOverlay", false);
            });
          } else {
            if (elethis.payload.catalogue) {
              for (var i = 0; i < elethis.payload.catalogue.length; i++) {
                elethis.payload.catalogue[i].qtty = 0;
                elethis.payload.catalogue[i].isOrdered = false;
              }
            }
            Vue.nextTick(() => {
              //controller.resume();
              elethis.set_overlay = false;
              // store.dispatch("setOverlay", false);
            });
          }
        }
      );
    },
    loadLocale_(id, callback) {
      downloadUrl("locale.json")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          fetch(data.message, {
            method: "GET",
            redirect: "follow",
          })
            .then((response) => response.text())
            .then((result) => {
              result = JSON.parse(result);
              i18n.locale = result.locale;
              callback(null);
            })
            .catch((error) => {
              i18n.locale = "en";
              console.log("error", error);
            });
        })
        .catch((error) => {
          i18n.locale = "en";
          console.log("Error", error);
        });
    },
    loadFile_(id, pos, callback) {
      var elethis = this;
      downloadUrl("catalogue" + pos + ".json")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          fetch(data.message, {
            method: "GET",
            redirect: "follow",
          })
            .then((response) => response.text())
            .then((result) => {
              //console.log(result);
              var strval = result;
              if (!strval) strval = "[]";
              var newfile = JSON.parse(strval);
              // debugger;
              // state.currentForm.id = appid;
              // setCurrentFormData(newfile, state);
              // store.dispatch("setCurrentFormData", newfile);
              elethis.payload.id = id;
              elethis.payload.pos = pos;
              elethis.payload.createdOn = newfile.createdOn;
              elethis.payload.currency = newfile.currency;
              elethis.payload.symbol = newfile.symbol;
              elethis.payload.shopname = newfile.shopname;
              elethis.payload.shopdesc = newfile.shopdesc;
              elethis.payload.type = newfile.type;
              elethis.payload.nationalNumber = newfile.nationalNumber;
              elethis.payload.phone = newfile.phone;
              if (elethis.payload.catalogue) {
                while (elethis.payload.catalogue.length > 0)
                  elethis.payload.catalogue.pop();
              } else {
                elethis.payload.catalogue = [];
              }

              if (!newfile.catalogue) newfile.catalogue = [];
              for (var i = 0; i < newfile.catalogue.length; i++)
                elethis.payload.catalogue.push(newfile.catalogue[i]);

              var maxpos = 0;

              for (var j = 0; j < newfile.catalogue.length; j++)
                if (newfile.catalogue[j].pos >= maxpos)
                  maxpos = newfile.catalogue[j].pos + 1;

              elethis.payload.maxlength = maxpos;
              // this.payload.catalogue.maxlength = maxpos;
              callback(null);
            })
            .catch((error) => {
              console.log("error", error);
              callback(error);
            });
        })
        .catch((error) => {
          console.log("Error", error);
          callback(error);
        });
    },
    async sendOTP() {
      if (this.country.dialCode && this.mobileno && this.mobileno.length > 1) {
        var phone = this.country.dialCode + "" + this.mobileno;
        if (this.isValid) {
          this.previous_number = phone;
          this.countDown = 60;
          this.counter_flag = true;
          this.countDownTimer();
          phone = parseInt(phone);
          if (this.country.dialCode == 91) {
            const msg = await sendOtpMessage(phone, false);
            if (msg != "") {
              alert("You are re-trying too early. Please wait for some time");
            }
            this.Initial_OTP = true;
          } else {
            const msg = await sendOtpMessage(phone, true);
            if (msg != "") {
              alert("You are re-trying too early. Please wait for some time");
            }
            this.Initial_OTP = true;
          }
        } else alert(i18n.t("newUi.OTPFlow.invalidPhone"));
      } else if (!this.country.dialCode) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterCountryCode"));
      } else if (!this.mobileno || this.mobileno.length == 1) {
        alert(i18n.t("newUi.OTPFlow.kindlyEnterPhoneNumber"));
      }
      // this.countDownTimer()
    },
    async sendOTP_Mobile() {
      if (this.country.dialCode && this.mobileno && this.mobileno.length > 1) {
        var phone = this.country.dialCode + "" + this.mobileno;
        // var regx = /^[6-9]\d{9}$/;
        if (this.isValid) {
          this.previous_number = phone;
          this.countDown = 60;
          this.counter_flag = true;
          this.countDownTimer();
          phone = parseInt(phone);
          if (this.country.dialCode == 91) {
            const msg = await sendOtpMessage(phone, false);
            if (msg != "") {
              alert("You are re-trying too early. Please wait for some time");
            }
            this.Initial_OTP = true;
          } else {
            const msg = await sendOtpMessage(phone, true);
            if (msg != "") {
              alert("You are re-trying too early. Please wait for some time");
            }
            this.Initial_OTP = true;
          }
        } else alert(i18n.t("newUi.OTPFlow.invalidPhone"));
      } else if (!this.country.dialCode) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterCountryCode"));
      } else if (!this.mobileno || this.mobileno.length == 1) {
        alert(i18n.t("newUi.OTPFlow.kindlyEnterPhoneNumber"));
      }
      // this.countDownTimer()
    },
    countDownTimer() {
      if (this.countDown > 0 && this.counter_flag) {
        this.toggleOTP = true;
        this.countDown -= 1;
        setTimeout(() => {
          this.otpText();
          this.countDownTimer();
        }, 1000);
      } else {
        this.countDown = 60;
        this.toggleOTP = false;
      }
    },
    otpText() {
      if (this.countDown === 0 || this.countDown === 60) {
        if (this.Initial_OTP) this.OTP_text = i18n.t("newUi.OTPFlow.resendOTP");
        else this.OTP_text = i18n.t("newUi.OTPFlow.GetOTP");
      } else {
        this.OTP_text =
          i18n.t("newUi.OTPFlow.resendOTP") +
          " (" +
          this.countDown +
          " " +
          i18n.t("newUi.OTPFlow.seconds") +
          ")";
        // this.toggleOTP=false;
      }
    },
    OTP_Verification: async function() {
      if (!this.mobileno || this.mobileno.length == 1) {
        alert(i18n.t("newUi.OTPFlow.kindlyEnterPhoneNumber"));
      } else if (!this.country.dialCode) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterCountryCode"));
      } else if (!this.OTP) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterOTP"));
      } else if (this.OTP) {
        var regx = /^[0-9]\d{3}$/;
        // var regx2 = /^[6-9]\d{9}$/;
        // var regx3=/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm;
        // const phone=this.country.dialCode+""+this.mobileno;
        if (!this.isValid) {
          alert(i18n.t("newUi.OTPFlow.invalidPhone"));
        } else if (!regx.test(this.OTP)) {
          this.OTP = "";
          alert(i18n.t("newUi.OTPFlow.invalidOTP"));
          console.log("valid OTP");
          // api call for validating OTP
        } else {
          this.form_otp_desktop = false;
          this.set_overlay = true;
          let response = await save(
            this.payload,
            this.country.dialCode,
            this.mobileno,
            this.OTP
          );
          // console.log('response',response);
          if (response.Order_id) {
            let Order_id = response.Order_id;
            this.payload.OrderId = Order_id;
            this.set_overlay = false;
            store.dispatch("setOrderId", Order_id);
            this.form_place_order_desktop = true;
          } else {
            this.set_overlay = false;
            this.OTP = "";
            this.form_otp_desktop = true;
            let errorMessage = response.message;
            if (errorMessage == "Kindly Generate New OTP") {
              errorMessage = i18n.t("newUi.OTPFlow.newOTP");
            } else if (errorMessage == "Please enter a valid OTP") {
              errorMessage = i18n.t("newUi.OTPFlow.invalidOTPServer");
            } else {
              errorMessage = i18n.t("newUi.OTPFlow.somethingWentWrong");
            }

            setTimeout(() => {
              alert(errorMessage);
            }, 500);
          }
        }
      }
    },
    OTP_Verification_mobile: async function() {
      if (!this.mobileno || this.mobileno.length == 1) {
        alert(i18n.t("newUi.OTPFlow.kindlyEnterPhoneNumber"));
      } else if (!this.country.dialCode) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterCountryCode"));
      } else if (!this.OTP_mobile) {
        alert(i18n.t("newUi.OTPFlow.KindlyEnterOTP"));
      } else if (this.OTP_mobile) {
        // const phone=this.country.dialCode+""+this.mobile;
        // const value= isValidPhoneNumber(phone,this.country.iso2);
        var regx = /^[0-9]\d{3}$/;
        // var regx2 = /^[6-9]\d{9}$/;
        // var regx3=/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm;

        if (!this.isValid) {
          alert(i18n.t("newUi.OTPFlow.invalidPhone"));
        } else if (!regx.test(this.OTP_mobile)) {
          this.OTP_mobile = "";
          alert(i18n.t("newUi.OTPFlow.invalidOTP"));
          // api call for validating OTP
        } else {
          this.form_otp = false;
          this.set_overlay = true;
          let response = await save(
            this.payload,
            this.country.dialCode,
            this.mobileno,
            this.OTP_mobile
          );
          if (response.Order_id) {
            let Order_id = response.Order_id;
            this.payload.OrderId = Order_id;
            this.set_overlay = false;
            store.dispatch("setOrderId", Order_id);
            this.form_place_order = true;
          } else {
            this.set_overlay = false;
            this.OTP_mobile = "";
            this.form_otp = true;
            let errorMessage = response.message;

            if (errorMessage == "Kindly Generate New OTP") {
              errorMessage = i18n.t("newUi.OTPFlow.newOTP");
            } else if (errorMessage == "Please enter a valid OTP") {
              errorMessage = i18n.t("newUi.OTPFlow.invalidOTPServer");
            } else {
              errorMessage = i18n.t("newUi.OTPFlow.somethingWentWrong");
            }

            setTimeout(() => {
              alert(errorMessage);
            }, 500);
          }
        }
      }
    },
    navws: async function() {
      var phoneno = this.payload.phone;
      var msg = this.composeMessage(this.payload);
      var url = this.createWhatsappUrl(phoneno, msg);

      let eventName = this.checkEventName();
      this.generateAnalytics(eventName, phoneno, msg);
      window.location.href = url;
    },
    navwsCatalog: async function() {
      var phoneno = this.payload.phone;
      var msg = this.composeMessageCatalog(this.payload);
      var url = this.createWhatsappUrl(phoneno, msg);

      let eventName = this.checkEventName();
      this.generateAnalytics(eventName, phoneno, msg);
      window.location.href = url;
    },
    createWhatsappUrl: function(phoneno, msg) {
      var url =
        "https://wa.me/" +
        encodeURI(phoneno) +
        "/?text=" +
        encodeURIComponent(msg);
      return url;
    },
    checkEventName: function() {
      let eventName = "wa_order_form";
      if (this.payload.type !== "Ordering form") {
        eventName = "wa_catalogue";
      }
      return eventName;
    },
    generateAnalytics: function(eventName, phoneno, msg) {
      analytics.logEvent(eventName, {
        phone: phoneno,
        msg: msg,
      });
    },
    composeMessageCatalog: function(form) {
      var msg =
        i18n.t("WhatsAppText.fillForm.catelogueText") +
        " \n\n*" +
        i18n.t("WhatsAppText.fillForm.header1") +
        "* x *" +
        i18n.t("WhatsAppText.fillForm.header3") +
        "*\n" +
        "";

      for (var i = 0; i < form.catalogue.length; i++) {
        var curitem = form.catalogue[i];
        if (curitem.type !== "item") continue;
        if (form.type === "Catalogue" && !curitem.isOrdered) continue;

        msg +=
          "" +
          (curitem.name +
            " " +
            (form.type === "Ordering form" ? " x " + curitem.qtty : "") +
            (form.type === "Catalogue" ? " : " + curitem.price : "")) +
          " \n";
      }
      msg +=
        "*" +
        i18n.t("WhatsAppText.fillForm.total") +
        "*\t" +
        form.symbol +
        form.amount+
        "\n";

      msg += "\n" + i18n.t("WhatsAppText.fillForm.confirm") + "\n";

      return msg;
    },
    composeMessage: function() {
      var msg =
        i18n.t("WhatsAppText.Order_confirmation") + " " + this.payload.OrderId;
      /* (form.type === "Ordering form"
            ? i18n.t("WhatsAppText.fillForm.orderFormText") +
              " \n\n*" +
              i18n.t("WhatsAppText.fillForm.header1") +
              "* x *" +
              i18n.t("WhatsAppText.fillForm.header2") +
              "*\n"
            : i18n.t("WhatsAppText.fillForm.catelogueText") +
              " \n\n*" +
              i18n.t("WhatsAppText.fillForm.header1") +
              "* x *" +
              i18n.t("WhatsAppText.fillForm.header3") +
              "*\n") + "";
        console.log('initial',msg);
        for (var i = 0; i < form.catalogue.length; i++) {
          var curitem = form.catalogue[i];
          if (curitem.type !== "item") continue;
          if (form.type === "Ordering form" && curitem.qtty < 1) continue;
          if (form.type === "Catalogue" && !curitem.isOrdered) continue;

          msg +=
            "" +
            (curitem.name +
              " " +
              (form.type === "Ordering form" ? " x " + curitem.qtty : "") +
              (form.type === "Catalogue" ? " x " + curitem.price : "")) +
            " \n";
        }
        console.log('Middle',msg);
        if (form.type === "Ordering form") {
          msg +=
            "*" +
            i18n.t("WhatsAppText.fillForm.total") +
            "*\tRs. " +
            form.amount +
            "\n";
        } else {
          msg +=
            "*" +
            i18n.t("WhatsAppText.fillForm.total") +
            "*\tRs. " +
            form.amount +
            "\n";
        }
        msg += "\n" + i18n.t("WhatsAppText.fillForm.confirm") + "\n";

        //alert("msg: " + msg);
        console.log('End',msg);*/
      return msg;
    },
  },
};
</script>
<style lang="scss">
.count_space {
  padding-left: 3px;
  padding-right: 3px;
}

.vti__dropdown-list {
  max-height: 150px !important;
}
input::-webkit-outer-spin-button,
input,
textarea {
  color: #8ab26d;
}
.tel-error {
  padding-top: 10px;
  margin-top: 10px;
  color: #dc3545;
  text-align: center;
}

.alignment_longText {
  word-break: break-all;
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.delete_dialog2 {
  width: 450px;
  height: 320px;
  background-color: #f8faf7;
}
.w3-input {
  border: none;
  border-bottom: solid;
  border-bottom-width: thin;
}
textarea:focus,
input:focus {
  outline: none;
}
.delete_dialog {
  height: 180px;
  width: 400px !important;
  background-color: #fff;
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
.background_color {
  background-color: #f8faf7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.description-text {
  text-align: justify;
  padding-right: 30px !important;
}
.consumer-product .item_box .item_text {
  min-height: auto;
}
.consumer-product .item_box .text_body {
  min-height: auto;
}
.consumer-product .item_box .d-flex .item_text {
  align-items: center;
}
@media (min-width: 1450px) {
  .grid-container2 {
    grid-template-columns: repeat(4, 1fr) !important;
  }
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #31333e;
    border-radius: 5px;
  }
}
@media (min-width: 960px) {
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #31333e;
    border-radius: 5px;
  }
  .grid-container2 {
    grid-template-columns: repeat(4, 1fr);
    display: grid;
    grid-gap: 5px;
  }
  .desktop-margins {
    margin-top: 5%;
    margin-left: 12%;
    margin-right: 12%;
  }
  .header-text {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #31333e;
    opacity: 1;
  }
  .delete_dialog1 {
    width: 450px;
    height: 300px;
    background-color: #f8faf7;
  }
  .button_padding {
    margin-right: 10px;
    padding: 10px;
    font-weight: bold;
    color: white !important;
    text-align: center;
    font-size: 12px;
    letter-spacing: 0px;
    text-transform: none;
    cursor: pointer;
  }
  .logo_white {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .logo_green {
    text-align: left;
    font-size: 24px;
    font-style: italic;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
  }
  .header-userflow {
    background: #31333e 0% 0% no-repeat padding-box;
    width: 100%;
    box-shadow: 0px 3px 20px #00000029;
  }
  .heading_user {
    text-align: left;
    letter-spacing: 0px;
    padding-left: 3%;
    padding-top: 1%;
    padding-bottom: 1%;
  }
  .consumer-product .imageview {
    height: auto;
    display: block;
    width: 100%;
    height: auto;
  }
  .consumer-product .imageview img {
    max-height: initial;
    width: 100%;
    max-width: 100%;
  }
  .consumer-product .row {
    margin-top: 0;
    margin-bottom: 0;
    align-items: flex-start;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .grid-container2 {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 2px;
  }
  .background_color {
    background-color: #f8faf7;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
  }
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #8ab26d;
    border-radius: 5px;
  }
  .button_padding {
    margin-right: 10px;
    padding: 10px;
    font-weight: bold;
    color: white !important;
    text-align: center;
    font-size: 12px;
    letter-spacing: 0px;
    text-transform: none;
    cursor: pointer;
  }
  .closeIcon {
    float: right;
    padding-top: 10px;
    padding-right: 15px;
  }
}
</style>
